import React from 'react';
import { Typography } from '@tmt-insights/oms_fe_core/material';
import { getLineageMetaTitle } from '@tmt-insights/oms_fe_core/utils';
import { TitleHierarchyComponent } from '@tmt-insights/oms_fe_core';

const TitleHierarchy: TitleHierarchyComponent = ({ title, versionName }) => {
  return (
    <>
      <Typography variant="body1" style={{ fontWeight: 'bold' }}>
        {title.lineage_meta?.series_name}
      </Typography>
      <Typography variant="caption">{getLineageMetaTitle(title)}</Typography>
      {versionName && (
        <>
          <br />
          <Typography variant="caption" sx={{ color: '#667799' }}>
            {versionName}
          </Typography>
        </>
      )}
    </>
  );
};

export default TitleHierarchy;
